<template>
  <div v-if="purchase && purchase.order_unit" :class="compact ? 'supplier-purchase-compact' : 'supplier-purchase-summary'">
    <template v-if="!compact">
      <h6 class="mb-1">{{ $t('supplier_purchase.title') }}</h6>
      <small class="text-muted d-block mb-2">{{ purchase.supplier_name }} · {{ $t('supplier_purchase.readonly_help') }}</small>
    </template>
    <CBadge v-if="showUnitBadge && (isPackaged || !compact)" color="info" class="d-inline-flex align-items-center flex-gap-1 mr-1"
      v-c-tooltip="$t('supplier_purchase.title') + ': ' + purchase.supplier_name">
      <CIcon name="cil-layers" /> {{ unitLabel }} × {{ purchase.order_unit.base_product_quantity }}
    </CBadge>
    <CBadge v-if="hasDeposit" color="success" class="d-inline-flex align-items-center flex-gap-1" v-c-tooltip="depositTooltip">
      <CIcon name="cil-recycle" /> {{ $t('returnable_packaging.deposit_badge') }}
    </CBadge>
    <div v-if="!compact && purchase.order_unit.price" class="small mt-2">
      {{ $t('returnable_packaging.sale_price_excluding_deposit') }}:
      {{ purchase.order_unit.price.amount | toCurrency(purchase.order_unit.price.currency) }}
      <span v-if="hasDeposit && purchase.order_unit.deposit_estimate.complete" class="ml-3">
        {{ $t('returnable_packaging.deposit_badge') }}:
        {{ purchase.order_unit.deposit_estimate.amount | toCurrency(purchase.order_unit.deposit_estimate.currency) }}
      </span>
    </div>
    <div v-if="!compact && hasDeposit" class="small mt-2">
      <span v-for="component in purchase.order_unit.deposit_components" :key="component.returnable_container_id" class="mr-3">
        {{ component.name }} × {{ component.quantity_per_unit }}
      </span>
    </div>
    <slot v-if="!compact" />
  </div>
</template>

<script>
export default {
  name: 'SupplierPurchaseSummary',
  props: { purchase: { type: Object, default: null }, compact: { type: Boolean, default: true }, showUnitBadge: { type: Boolean, default: true } },
  computed: {
    isPackaged() { return this.purchase?.order_unit?.code !== 'piece'; },
    hasDeposit() { return (this.purchase?.order_unit?.deposit_components || []).length > 0; },
    depositTooltip() {
      return [this.$t('supplier_purchase.title') + ': ' + this.purchase?.supplier_name,
        ...(this.purchase?.order_unit?.deposit_components || []).map(component => component.name + ' × ' + component.quantity_per_unit),
      ].join('\n');
    },
    unitLabel() {
      const code = this.purchase?.order_unit?.code;
      if (!['piece', 'case', 'pack', 'keg', 'bottle', 'pallet', 'other'].includes(code)) return this.purchase?.order_unit?.label || code;
      return this.$t(code === 'piece' ? 'returnable_packaging.unit_piece' : 'returnable_packaging.kind_' + code);
    },
  },
};
</script>

<style scoped>
.supplier-purchase-compact { display: inline-flex; align-items: center; flex-wrap: wrap; margin-top: 0.25rem; }
.supplier-purchase-summary { padding: 0.85rem; border: 1px solid #dce8f2; border-radius: 0.5rem; background: #f4f8fc; margin-bottom: 1rem; }
</style>
